import { cats } from "@/mocks/home";

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            <i className="ri-apps-2-line"></i>主题分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            按栏目挑你爱吃的瓜
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            六大栏目聚合一手消息，实时动态按栏目持续刷新，直达你最关心的话题。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cats.map((c, i) => (
            <a
              key={c.name}
              href="#fresh"
              className="fade-up group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-accent-300 hover:bg-accent-100/60"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <span
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-xl ${c.color}`}
              >
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-lg font-black text-foreground-950">{c.name}</span>
                  <span className="flex h-5 items-center whitespace-nowrap rounded-full bg-secondary-100 px-2 text-[11px] font-semibold text-secondary-900">
                    实时
                  </span>
                </span>
                <span className="mt-1 block truncate text-sm text-foreground-600">{c.desc}</span>
              </span>
              <i className="ri-arrow-right-line text-foreground-300 transition group-hover:translate-x-1 group-hover:text-primary-500"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}